import { ChartArtifactView } from "./ChartArtifact";
import { DownloadArtifactView } from "./DownloadArtifact";
import { QueryResultArtifactView } from "./QueryResultArtifact";
import { TableArtifactView } from "./TableArtifact";
import type { Artifact } from "./types";

export function ArtifactRenderer({ artifact }: { artifact: Artifact }) {
  switch (artifact.type) {
    case "text":
      return <div className="artifact">{artifact.content}</div>;
    case "table":
      return <TableArtifactView artifact={artifact} />;
    case "chart":
      return <ChartArtifactView artifact={artifact} />;
    case "query_result":
      return <QueryResultArtifactView artifact={artifact} />;
    case "download":
      return <DownloadArtifactView artifact={artifact} />;
    default: {
      const _exhaustive: never = artifact;
      return <div className="artifact">unknown artifact: {JSON.stringify(_exhaustive)}</div>;
    }
  }
}
